<div
  class="ebo-input"
  [class.ebo-input--error]="hasError"
  [class.ebo-input--focused]="isFocused"
>
  <!-- Label -->
  <span *ngIf="label" class="ebo-input__label">
    {{ label }}
    <span *ngIf="required" class="ebo-input__required">*</span>
  </span>

  <!-- Input Control -->
  <input
    [type]="type"
    [placeholder]="placeholder"
    [value]="control?.value || ''"
    (input)="onInputChange($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
    class="ebo-input__control"
    [attr.aria-label]="label"
    [attr.aria-required]="required"
  />

  <!-- Hint Text -->
  <span *ngIf="hint && !hasError" class="ebo-input__hint">
    {{ hint }}
  </span>

  <!-- Error Text -->
  <span *ngIf="hasError" class="ebo-input__error">
    {{ errorMessage }}
  </span>
</div>
